const DOMAIN = import.meta.env.VITE_DOMAIN_BASE.replace('/api', '');
let currentFontStyleId: string | null = null;

export const loadFontOnce = async (fontName: string, path: string) => {
  if (currentFontStyleId) {
    const oldStyle = document.getElementById(currentFontStyleId);
    if (oldStyle) oldStyle.remove();
  }
  const style = document.createElement('style');
  const styleId = `font-${fontName.replace(/\s+/g, '-')}`;
  style.id = styleId;
  style.textContent = `
    @font-face {
      font-family: '${fontName} EXPORT';
      src: local("${fontName}"), url("${DOMAIN}${path}") format("truetype");
      font-display: swap;
    }
  `;
  document.head.appendChild(style);
  currentFontStyleId = styleId;

  try {
    await document.fonts.load(`1em '${fontName} EXPORT'`);
    await document.fonts.ready;
    console.log(`Font '${fontName} EXPORT' loaded and ready.`);
  } catch (err) {
    console.error(`Failed to load font '${fontName} EXPORT'`, err);
  }
};

export const waitForFontToRender = (el: HTMLElement, timeout = 1000): Promise<void> => {
  return new Promise((resolve) => {
    if (!el) return resolve();
    let resolved = false;
    const initial = el.getBoundingClientRect();

    const done = () => {
      if (resolved) return;
      resolved = true;
      observer.disconnect();
      resolve();
    };

    const observer = new ResizeObserver(() => {
      const rect = el.getBoundingClientRect();
      if (rect.width !== initial.width || rect.height !== initial.height) {
        done(); // font visually changed something
      }
    });

    observer.observe(el);

    // fallback: just in case no visual change
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!resolved) done();
      });
    });

    // final fallback: timeout protection
    setTimeout(done, timeout);
  });
};
